import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getStatementList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import DeleteStatementModal from './Modals/DeleteStatementModal';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import ChargeStatementDocumentModal from './Modals/ChargeStatementDocumentModal';
import GuideListStatementModal from './Modals/GuideListStatementModal';
import FilesStatementModal from './Modals/FilesStatementModal';
import { Tooltip } from '@mantine/core';

const StatementsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorStatements = createSelector(
		state => state.Statements,
		statement => ({
			statementList: statement.statementList,
			isLoadingList: statement.isLoadingList,
			isStatementSuccess: statement.isStatementSuccess,
			error: statement.error,
			isAdding: statement.isAdding,
			isAdded: statement.isAdded,
			isAddError: statement.isAddError,
			isUpdating: statement.isUpdating,
			isUpdated: statement.isUpdated,
			isUpdateError: statement.isUpdateError,
			isDeleting: statement.isDeleting,
			isDeleted: statement.isDeleted,
			isDeleteError: statement.isDeleteError,
		})
	);

	const { statementList, isLoadingList, } = useSelector(selectorStatements);

	useEffect(() => {
		dispatch(getStatementList());
	}, []);

	const [dataStatement, setDataStatement] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Statement
	const [modal, setModal] = useState(false);
	const [modalView, setModalView] = useState(false);
	const [modalFilesStatement, setModalFilesStatement] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
	}

	function handleToggleModalView() {
		setModalView(!modalView);
	}

	function handleToggleModalFilesStatement() {
		setModalFilesStatement(!modalFilesStatement);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = statement => {
		setDataStatement(statement);
		setModalDelete(true);
	};

	// Update Data
	const handleClickFilesStatement = statement => {
		setDataStatement(statement);
		handleToggleModalFilesStatement();
	};

	// Update Data
	const handleClickEdit = statement => {
		setDataStatement(statement);
		handleToggleModal();
	};

	// View Data
	const handleClickView = statement => {
		setDataStatement(statement);
		setModalView(true);
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'statement',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const statementData = cellProps.row.original;
													setIsEdit(true);
													handleClickView(statementData);
												}}
												title='Ver residuos declarados'
											>
												<i className='ri-search-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const statementData = cellProps.row.original;
													handleClickFilesStatement(statementData);
												}}
												title='Ver Documentos'
											>
												<i className='ri-file-search-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className={`list-inline-item ${!cellProps.row.original.document_statement_id ? '' : 'disabled'}`}>
											<Link
												to='#'
												onClick={() => {
													if (!cellProps.row.original.document_statement_id) {
														const statementData = cellProps.row.original;
														setIsEdit(true);
														handleClickEdit(statementData);
													}
												}}
												title='Cargar Certificado de Declaración'
											>
												<i className='ri-upload-2-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const statementData = cellProps.row.original;
													handleClickDelete(statementData);
												}}
												title='Eliminar declaración'
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Fecha declaración',
				accessorKey: 'date_document_statement',

				Cell: ({ row }) => {
					const { date_document_statement } = row.original;
					const date_document_statement_formated = (date_document_statement != null ?
						`${String(new Date(date_document_statement).getDate()).padStart(2, '0')}-${String(new Date(date_document_statement).getMonth() + 1).padStart(2, '0')}-${new Date(date_document_statement).getFullYear()}`
						:
						'Sin fecha'
					);

					return date_document_statement_formated;
				},
			},
			{
				header: 'Estado',
				accessorKey: 'status_statement.name',

				size: 'auto',
				Cell: ({ row }) => {
					const { name, bgcolor, txtcolor } = row.original.status_statement;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgcolor, color: txtcolor }}>
								{name}
							</span>
						</div>
					);
				}
			},
			{ header: 'Origen', accessorKey: 'establishment.name', size: 'auto', },
			{ header: 'Kg Declarados', accessorKey: 'kilograms_declared', size: 'auto', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<Link
											to={'/residue/statement/new'}
											className='nav-link'
											data-key='t-basic-action'
										>
											<button className='btn btn-label btn-primary'>
												<i className={`${Icons.plus} label-icon`}></i>{' '}
												Nueva declaración
											</button>
										</Link>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={statementList || []}
								isLoadingData={isLoadingList}
								nameFile={'declaraciones'}
								customToolbarActions={({ table }) => (
									<div className="d-flex justify-content-start gap-2">
										<Link
											to={'/residue/statement/new'}
											className='nav-link'
											data-key='t-basic-action'
										>
											<Tooltip label='Nueva declaración' position='top' withinPortal>
												<button className='btn d-flex align-items-center btn-tooltip-hover gap-1'>
													<i className='icon-plus icon-tooltop-size'></i>{' '}
													Nueva
												</button>
											</Tooltip>
										</Link>
									</div>
								)}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
			<GuideListStatementModal
				data={dataStatement}
				isEdit={isEdit}
				isOpen={modalView}
				handleToggleModal={handleToggleModalView}
			/>
			<FilesStatementModal
				data={dataStatement}
				isOpen={modalFilesStatement}
				handleToggleModal={handleToggleModalFilesStatement}
			/>
			<ChargeStatementDocumentModal
				data={dataStatement}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteStatementModal
				data={dataStatement}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default StatementsList;
